import React from 'react';
import ImpactStatGroup from './ImpactStatGroup';
import styled from 'styled-components';

const StatWrapper = styled.div`
	margin: 0 0 5em;

	&:nth-of-type(even) > :first-child {
		order: 2;
	}

	img {
		object-fit: cover;
		width: 100%;
		height: 300px;
		max-width: 500px;
		border-radius: 5px;
		margin-top: 3em;
	}

	@media screen and (min-width: 650px) {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 0 0 4em;

		img {
			height: 600px;
		}
	}
`;

const ImpactGroup = ({image, details}) => {
	return (
		<StatWrapper>
			<ImpactStatGroup number={details.number} unit={details.unit} description={details.description} />
			{image && <img src={image} loading="lazy" alt={details.unit} />}
		</StatWrapper>
	);
};

export default ImpactGroup;
